// extracted by mini-css-extract-plugin
export default {"btnWrapper":"switchFormButtons-module__btnWrapper__Ty+Ly","button":"switchFormButtons-module__button__B49bC","activeButton":"switchFormButtons-module__activeButton__klAxu"};